import { useEffect, useState, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Typography,
  IconButton,
  Stack,
  TextField,
  Paper,
  Avatar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NameSearchComponent from "../../components/customTable/NameSearchComponent";
import { inactivePartnerApi } from "../../app/slices/partnerReport/inactivePartnerSlice";
import axios from "axios";
import axiosInstance from "../../utils/axiosInstance";

export default function InactivePartner() {
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  // const navigate = useNavigate();

  const sliceResponse = useSelector(
    (state) => state.inactivePartner.inactivePartner.data
  );
  const stateLoading = useSelector((state) => state.inactivePartner.loading);

  const [searchTerm, setSearchTerm] = useState("");
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });

  const [openDialog, setOpenDialog] = useState(false);
  const [dialogData, setDialogData] = useState([]);

  const fetchAadharData = useCallback(() => {
    let params = {};
    if (searchTerm) {
      params.name = searchTerm;
    } else if (queryParams.startDate && queryParams.endDate) {
      params.startDate = queryParams.startDate;
      params.endDate = queryParams.endDate;
    }
    dispatch(inactivePartnerApi(params));
  }, [dispatch, searchTerm, queryParams]);

  useEffect(() => {
    fetchAadharData();
  }, [fetchAadharData]);

  const handleSearchByName = (name) => {
    setQueryParams({ startDate: null, endDate: null });
    setSearchTerm(name);
  };

  const handleOpenDialog = async (username) => {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    };
    try {
      const response = await axiosInstance.post(
        `/partner_details`,
        { username },
        // { headers }
      );
      // const response = await axios.post(
      //   `${baseUrl}/partner_details`,
      //   { username },
      //   { headers }
      // );
      setDialogData(response.data.data);
      setOpenDialog(true);
    } catch (error) {
      console.error("Error fetching partner details:", error);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setDialogData([]);
  };

  // const handleNavigateToDetails = () => {
  //   navigate("/partner-details", { state: { partner: dialogData?.[0] } });
  // };

  const columnHelper = createMRTColumnHelper();

  const columns = useMemo(
    () => [
      columnHelper.accessor("partner_username", {
        header: "Username",
        size: 150,
        Cell: (cell) => cell.row.original?.partner_username,
      }),
      columnHelper.accessor("partner_name", {
        header: "Name",
        size: 200,
        Cell: (cell) => (
          <Button
            variant="text"
            onClick={() =>
              handleOpenDialog(cell.row.original?.partner_username)
            }
          >
            {cell.row.original?.partner_name}
          </Button>
        ),
      }),
      columnHelper.accessor("partner_email", {
        header: "Email",
        size: 250,
        Cell: (cell) => cell.row.original?.partner_email,
      }),
      columnHelper.accessor("partner_mobileNo", {
        header: "Mobile No",
        size: 150,
        Cell: (cell) => cell.row.original?.partner_mobileNo,
      }),
      columnHelper.accessor("partner_pan", {
        header: "PAN",
        size: 150,
        Cell: (cell) => cell.row.original?.partner_pan,
      }),
      columnHelper.accessor("partner_address", {
        header: "Address",
        size: 250,
        Cell: (cell) => cell.row.original?.partner_address,
      }),
      columnHelper.accessor("partner_city", {
        header: "City",
        size: 150,
        Cell: (cell) => cell.row.original?.partner_city,
      }),
      columnHelper.accessor("partner_state", {
        header: "State",
        size: 150,
        Cell: (cell) => cell.row.original?.partner_state,
      }),
      columnHelper.accessor("partner_augmont_commission_per", {
        header: "Augmont Commission (%)",
        size: 350,
        Cell: (cell) => `${cell.row.original?.partner_augmont_commission_per}%`,
      }),
      columnHelper.accessor("partner_mmtc_commission_per", {
        header: "MMTC Commission (%)",
        size: 200,
        Cell: (cell) => `${cell.row.original?.partner_mmtc_commission_per}%`,
      }),
      columnHelper.accessor("status", {
        header: "Status",
        size: 150,
        Cell: (cell) => cell.row.original?.status,
      }),
    ],
    [columnHelper]
  );

  // partner object is first item of dialogData array or empty object
  const partnerData = dialogData?.[0] || {};
  //   console.log("data:::::::::::::::::::::::::::::::::::::::::",partnerData)

  return (
    <>
      <Box display="flex" justifyContent="space-between" mb={2}>
        <NameSearchComponent onSearch={handleSearchByName} />
      </Box>

      <CustomTable
        columns={columns}
        data={sliceResponse}
        loading={stateLoading}
        permissionKey="ActivePartner"
      />

      {/* Partner Details Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="80%"
      >
        <DialogTitle>
          Partner Details
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={3} >
            {/* Left Section: Profile Image and Basic Info */}
            <Grid item xs={12} md={3} sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
              <Paper evalution={4} sx={{ p: 2 }}>
                <Avatar
                  src="https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_items_boosted&w=740"
                  alt="User Avatar"
                  sx={{ width: 100, height: 100, mx: "auto", mb: 3 }}
                />
                <Box sx={{ display: "flex", flexDirection: "column", textAlign: "center" }}>
                  <Typography>
                    <span style={{ fontWeight: "bold" }}>Name: </span>  {partnerData?.name || "N/A"}
                  </Typography>
                  <Typography>
                    <span style={{ fontWeight: "bold" }}>D.O.B:</span>    {partnerData?.dob || "N/A"}
                  </Typography>


                  <Typography>
                    <span style={{ fontWeight: "bold" }}>Mob No.:</span> {" "}
                    {partnerData?.mobileNo || "N/A"}
                  </Typography>
                  <Typography>
                    <span style={{ fontWeight: "bold" }}>Email:</span> {partnerData?.email || "N/A"}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
            {/* Right Section: Details */}
            <Grid item xs={12} md={9}>
              {/* <Paper elevation={3} sx={{ p: 2 }}> */}
              {/* Personal Details */}
              <Box mb={3}>
                <Typography
                  variant="h6"
                  gutterBottom
                  style={{
                    color: "black",
                    padding: "2px",
                    borderBottom: "2px solid black",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  Personal Details
                </Typography>
                <Grid container spacing={2}>
                  {/* <Grid item xs={12} md={12} sx={{ display: "flex", justifyContent: "space-between", textAlign: "center" }}>
                    <Typography>
                      <strong>Username:</strong>{" "}<br></br>
                      {partnerData?.userName || "N/A"}
                    </Typography>

                    <Typography>
                      <strong>Aadhar No.:</strong>{" "}<br></br>
                      {partnerData?.identificationNo || "N/A"}
                    </Typography>
                    <Typography>
                      <strong>Register Type:</strong>{" "}<br></br>
                      {partnerData?.registerType || "N/A"}
                    </Typography>
                    <Typography>
                      <strong>Entity Type:</strong>{" "}<br></br>
                      {partnerData?.EntityType || "N/A"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={12} sx={{ display: "flex", justifyContent: "space-between", textAlign: "center" }}>
                    <Typography>
                      <strong>Auth Person Name:</strong>{" "}<br></br>
                      {partnerData?.authpersonName || "N/A"}
                    </Typography>
                    <Typography>
                      <strong>GSTIN:</strong>{" "}<br></br>
                      {partnerData?.Gstin || "N/A"}
                    </Typography>
                    <Typography>
                      <strong>Commission Per:</strong>{" "}<br></br>
                      {partnerData?.commission_per || "N/A"}
                    </Typography>
                    <Typography>
                      <strong>Mmtc Commission Per:</strong>{" "}<br></br>
                      {partnerData?.mmtc_commission_per || "N/A"}
                    </Typography>
                  </Grid> */}

                  {/* First Row */}
                  <Grid
                    item
                    xs={12}
                    md={12}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      textAlign: "center",
                    }}
                  >
                    {[
                      { label: "Username", value: partnerData?.userName || "N/A" },
                      { label: "Aadhar No.", value: partnerData?.identificationNo || "N/A" },
                      { label: "Register Type", value: partnerData?.registerType || "N/A" },
                      { label: "Entity Type", value: partnerData?.EntityType || "N/A" },
                    ].map((item, index) => (
                      <Box
                        key={index}
                        sx={{
                          width: { xs: "100%", sm: "48%", md: "24%" },
                          mb: 2,
                          wordBreak: "break-word",
                        }}
                      >
                        <Typography>
                          <strong>{item.label}</strong>
                          <br />
                          {item.value}
                        </Typography>
                      </Box>
                    ))}
                  </Grid>

                  {/* Second Row */}
                  <Grid
                    item
                    xs={12}
                    md={12}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      textAlign: "center",
                    }}
                  >
                    {[
                      { label: "Auth Person Name", value: partnerData?.authpersonName || "N/A" },
                      { label: "GSTIN", value: partnerData?.Gstin || "N/A" },
                      { label: "Commission Per", value: partnerData?.commission_per || "N/A" },
                      { label: "Mmtc Commission Per", value: partnerData?.mmtc_commission_per || "N/A" },
                    ].map((item, index) => (
                      <Box
                        key={index}
                        sx={{
                          width: { xs: "100%", sm: "48%", md: "24%" },
                          mb: 2,
                          wordBreak: "break-word",
                        }}
                      >
                        <Typography>
                          <strong>{item.label}</strong>
                          <br />
                          {item.value}
                        </Typography>
                      </Box>
                    ))}
                  </Grid>

                </Grid>
              </Box>

              {/* Address Details */}
              <Box mb={2}>
                <Typography
                  variant="h6"
                  gutterBottom
                  style={{
                    color: "black",
                    padding: "2px",
                    borderBottom: "2px solid black",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  Address Details
                </Typography>
                <Grid container spacing={2}>
                  {/* <Grid item xs={12} md={12} sx={{ display: "flex", justifyContent: "space-between", textAlign: "center" }}>
                    <Typography>
                      <strong>{partnerData.EntityType ? "CompanyAddress" : "Address"}:</strong>{" "}<br></br>
                      {partnerData?.address || "N/A"}
                    </Typography>

                    <Typography>
                      <strong>State:</strong><br></br> {partnerData?.state || "N/A"}
                    </Typography>
                    <Typography>
                      <strong>City:</strong><br></br> {partnerData?.city || "N/A"}
                    </Typography>
                    <Typography>
                      <strong>Pin Code:</strong><br></br> {partnerData?.pincode || "N/A"}
                    </Typography>

                  </Grid> */}
                  <Grid
                    item
                    xs={12}
                    md={12}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      textAlign: "center",
                    }}
                  >
                    <Box
                      sx={{
                        width: { xs: "100%", sm: "48%", md: "24%" },
                        mb: 2,
                        wordBreak: "break-word",
                      }}
                    >
                      <Typography>
                        <strong>{partnerData.EntityType ? "Company Address" : "Address"}</strong>
                        <br />
                        {partnerData?.address || "N/A"}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        width: { xs: "100%", sm: "48%", md: "24%" },
                        mb: 2,
                        wordBreak: "break-word",
                      }}
                    >
                      <Typography>
                        <strong>State</strong>
                        <br />
                        {partnerData?.state || "N/A"}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        width: { xs: "100%", sm: "48%", md: "24%" },
                        mb: 2,
                        wordBreak: "break-word",
                      }}
                    >
                      <Typography>
                        <strong>City</strong>
                        <br />
                        {partnerData?.city || "N/A"}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        width: { xs: "100%", sm: "48%", md: "24%" },
                        mb: 2,
                        wordBreak: "break-word",
                      }}
                    >
                      <Typography>
                        <strong>Pin Code</strong>
                        <br />
                        {partnerData?.pincode || "N/A"}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Box>

              {/* Bank Details */}
              <Box>
                <Typography
                  variant="h6"
                  gutterBottom
                  style={{
                    color: "black",
                    padding: "2px",
                    borderBottom: "2px solid black",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  Bank Details
                </Typography>
                <Grid container spacing={2}>
                  {/* <Grid item xs={12} md={12} sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography sx={{ textAlign: "center" }}>
                      <strong>Account Holder's Name:</strong>{" "}<br></br>
                      {partnerData?.accHoldername || "N/A"}
                    </Typography>

                    <Typography>
                      <strong>Account No.:</strong>{" "}<br></br>
                      {partnerData?.accNo || "N/A"}
                    </Typography>
                    <Typography>
                      <strong>PAN No.:</strong>{" "}<br></br>
                      {partnerData?.panNo || "N/A"}
                    </Typography>
                    <Typography>
                      <strong>IFSC Code:</strong>{" "}<br></br>
                      {partnerData?.Ifsccode || "N/A"}
                    </Typography>
                  </Grid> */}


                  <Grid item xs={12} md={12} sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
                    {[{
                      label: "Account Holder's Name",
                      value: partnerData?.accHoldername || "N/A"
                    }, {
                      label: "Account No.",
                      value: partnerData?.accNo || "N/A"
                    }, {
                      label: "PAN No.",
                      value: partnerData?.panNo || "N/A"
                    }, {
                      label: "IFSC Code",
                      value: partnerData?.Ifsccode || "N/A"
                    }].map((item, index) => (
                      <Box
                        key={index}
                        sx={{
                          width: { xs: "100%", sm: "48%", md: "24%" },
                          mb: 2,
                          wordBreak: "break-word",
                          overflowWrap: "break-word"
                        }}
                      >
                        <Typography sx={{ fontWeight: "bold" }}>{item.label}</Typography>
                        <Typography>{item.value}</Typography>
                      </Box>
                    ))}
                  </Grid>
                </Grid>
              </Box>
              {/* </Paper> */}
            </Grid>
          </Grid>
          {/* Button */}
          {/* <Stack direction="row" justifyContent="flex-end" spacing={2} mt={4}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleNavigateToDetails}
            >
              Go to Details Page
            </Button>
          </Stack> */}
        </DialogContent>
      </Dialog>
    </>
  );
}
